import styled from 'styled-components';
import palette from '../../../lib/styles/palette';
import { useRef, useState, useEffect, useCallback } from 'react';

import { MdExpandMore, MdExpandLess, MdRemoveCircleOutline, MdAdd } from 'react-icons/md';
// import ActionButtons from "../ActionButtons";
// import AskCancelModal from "../AskCancelModal";

import { standardWeight_Damper } from '../../../lib/data/standard-weight';

const ChuteDamperForm = ({ onSaveStructure, onChangeWeightSummary, chuteDampers, beltWidth }) => {
    const [isShow, setIsShow] = useState(chuteDampers?.length || false);
    const [newChuteDamper, setNewChuteDamper] = useState(chuteDampers || []);
    const [factor, setFactor] = useState('1.0');
    const [id, setId] = useState('');
    const [typeCategory, setTypeCategory] = useState('');
    const [materialCategory, setMaterialCategory] = useState('');
    const [height, setHeight] = useState('3');
    const [standardWeight, setStandardWeight] = useState('');
    const [qty, setQty] = useState('');
    const [unitWeight, setUnitWeight] = useState('');
    const [weight, setWeight] = useState('');
    const [totalQty, setTotalQty] = useState('');
    const [totalWeight, setTotalWeight] = useState('');
    // const [modal, setModal] = useState(false);
    /* 변경사항을 저장했었는지 여부에 대한 상태 저장 */
    const [isChanged, setIsChanged] = useState(false);

    /* Category 설명하는 text */
    const typeCategoryText = useRef({
        0: 'Diverting(StoneBox)',
        1: 'Adjust(StoneBox)',
        2: 'Diverting(Straight)',
        3: 'Adjust(Straight)',
    });

    const materialCategoryText = useRef({
        0: 'Mild Steel',
        1: 'Stainless Steel',
    });

    /*  처음 props로 넘어온 chuteDampers를 초기값 그대로 보관하고 있다가 취소 버튼을 눌렀을 때 원상 복귀 시키기 위해
        useRef를 사용하여 저장해 둔다. */
    // const initialChuteDamper = useRef(chuteDampers || []);

    /* 벨트폭에 해당하는 Weight를 가져온다. */
    useEffect(() => {
        if (!standardWeight_Damper || !beltWidth) {
            return;
        }

        const library = standardWeight_Damper.find((item) => item.beltWidth === parseInt(beltWidth));
        if (!library) {
            alert('Check Belt Width!');
            return;
        }

        const index = parseInt(typeCategory);

        setStandardWeight(library.standardWeight[index]);
    }, [beltWidth, typeCategory]);

    /* 단위 중량 및 중량 자동 계산 */
    useEffect(() => {
        // if (!standardWeight || !factor) {
        //     return;
        // }
        const _unitWeight = Math.ceil(standardWeight * factor);
        setUnitWeight(_unitWeight);
    }, [factor, standardWeight]);

    /* 중량 계산 */
    useEffect(() => {
        // if (!unitWeight || !qty) {
        //     return;
        // }
        const _weight = Math.ceil(unitWeight * qty);
        setWeight(_weight);
    }, [qty, unitWeight]);

    /* 마지막 ID 가져오기 함수 */
    const getLastId = useCallback(() => {
        if (!newChuteDamper.length) {
            return 0;
        }
        return Math.max(...newChuteDamper.map((item) => Number(item.id.substring(4))), 0);
    }, [newChuteDamper]);

    /* 입력 후 폼 초기화 함수 */
    const initializeForm = useCallback(() => {
        setId(`CHD-${getLastId() * 1 + 1}`);
        // setLength('');
        // setStandardWeight('');
        // setFactor('');
        setQty('');
        setUnitWeight('');
        setWeight('');
    }, [getLastId]);

    /* 전체 수량 계산 함수 */
    const getTotalQty = useCallback((items) => {
        const _totalQty = items.reduce((accumulator, currentValue) => {
            return accumulator + parseInt(currentValue.qty);
        }, 0);
        setTotalQty(_totalQty);
    }, []);

    /* 전체 중량 계산 함수 */
    const getTotalWeight = useCallback((items) => {
        const _totalWeight = items.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.weight;
        }, 0);
        setTotalWeight(_totalWeight);
    }, []);

    /* 추가 버튼을 누르면 newChuteDamper에 chute 추가 */
    const onAddChuteDamper = useCallback(() => {
        // if (!weight) {
        //     alert('입력값을 확인하세요.');
        //     return;
        // };
        if (!qty || !unitWeight || !weight) {
            alert('Check input(s) before saving!!!!!!');
            return;
        }
        const chuteDamper = {
            id,
            damperType: typeCategoryText.current[typeCategory],
            materialType: materialCategoryText.current[materialCategory],
            height,
            standardWeight,
            factor,
            qty,
            unitWeight,
            weight,
        };
        setNewChuteDamper((prev) => [...prev, chuteDamper]);
        setIsChanged(true);
    }, [id, typeCategory, materialCategory, height, standardWeight, factor, qty, unitWeight, weight]);

    /* 삭제 버튼을 누르면 해당 chute 삭제 */
    const onDeleteChuteDamper = useCallback((id) => {
        setNewChuteDamper((prev) => prev.filter((item) => item.id !== id));
        setIsChanged(true);
    }, []);

    /* newChuteDamper에 변화가 생기면 리덕스에 변경사항 쓰기 */
    useEffect(() => {
        getTotalQty(newChuteDamper);
        getTotalWeight(newChuteDamper);
        initializeForm();
        onSaveStructure({
            key: 'chuteDamper',
            value: newChuteDamper,
        });
        onChangeWeightSummary({
            key: 'chuteDamper',
            value: {
                totalQty,
                totalWeight,
            },
        });
    }, [
        getTotalQty,
        getTotalWeight,
        initializeForm,
        newChuteDamper,
        onChangeWeightSummary,
        onSaveStructure,
        totalQty,
        totalWeight,
    ]);

    /* Save 버튼을 누르면 리덕스에 변경사항 쓰기 */
    // const onSaveChuteDamper = useCallback(() => {
    //     onSaveStructure({
    //         key: 'chuteDamper',
    //         value: newChuteDamper,
    //     });
    //     onChangeWeightSummary({
    //         key: 'chuteDamper',
    //         value: {
    //             totalQty,
    //             totalWeight,
    //         },
    //     });
    // }, [newChuteDamper, onChangeWeightSummary, onSaveStructure, totalQty, totalWeight]);

    /* 변경 사항을 취소하면 newChuteDamper를 초기값으로 변경하고 리덕스에 초기값으로 쓰기 */
    // const onCancelChange = useCallback(() => {
    //     setNewChuteDamper(initialChuteDamper.current);
    //     onSaveStructure({
    //         key: 'chuteDamper',
    //         value: initialChuteDamper.current,
    //     });
    //     onChangeWeightSummary({
    //         key: 'chuteDamper',
    //         value: {},
    //     });
    //     setModal(false);
    // }, [onChangeWeightSummary, onSaveStructure]);

    /* Cancel Change 버튼을 눌렀을 때 */
    // const onClickCancel = useCallback(() => {
    //     // 저장된 적이 없다면 alert
    //     if (!isChanged) {
    //         alert ('변경내용이 없습니다.');
    //         return;
    //     }
    //     setModal(true);
    // }, [isChanged]);

    return (
        <ChuteDamperFormBlock>
            <Title>
                <h3 style={{ width: '400px', margin: '0' }}>Chute(Damper)</h3>
                <div style={{ width: '120px' }}>Q'ty: {totalQty} ea</div>
                <div style={{ width: '170px' }}>Weight: {totalWeight} kg</div>
                <div style={{ fontSize: '1.25rem', fontWeight: 'bold', display: 'flex', alignItems: 'flex-end' }}>
                    {!isShow ? (
                        <MdExpandMore color="orange" onClick={() => setIsShow(true)} />
                    ) : (
                        <MdExpandLess color="orange" onClick={() => setIsShow(false)} />
                    )}
                </div>
            </Title>
            {isShow && (
                <>
                    <table>
                        <thead>
                            <tr>
                                <th>ID.</th>
                                <th>Type</th>
                                <th>Material</th>
                                <th>
                                    Standard W't
                                    <br />
                                    (kg/set)
                                </th>
                                <th>Factor</th>
                                <th>
                                    Unit
                                    <br />
                                    Weight
                                    <br />
                                    (kg/set)
                                </th>
                                <th>Q'ty</th>
                                <th>Weight(kg)</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {newChuteDamper &&
                                newChuteDamper.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.id}</td>
                                        <td>{item.damperType}</td>
                                        <td>{item.materialType}</td>
                                        <td>{item.standardWeight}</td>
                                        <td>{item.factor}</td>
                                        <td>{item.unitWeight}</td>
                                        <td>{item.qty}</td>
                                        <td>{item.weight}</td>
                                        <td className="btn-delete" onClick={() => onDeleteChuteDamper(item.id)}>
                                            <MdRemoveCircleOutline />
                                        </td>
                                    </tr>
                                ))}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr className="input-form">
                                {/* <td><StyledInput readOnly value={id} onChange={(e) => setId(e.target.value)} /></td> */}
                                <td className="id-column">{id}</td>
                                <td>
                                    <div className="input-radio">
                                        <label>
                                            <input
                                                type="radio"
                                                name="typeCategory"
                                                value="0"
                                                onChange={(e) => setTypeCategory(e.target.value)}
                                            />
                                            <span>Diverting (StoneBox)</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="typeCategory"
                                                value="1"
                                                onChange={(e) => setTypeCategory(e.target.value)}
                                            />
                                            <span>Adjust (StoneBox)</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="typeCategory"
                                                value="2"
                                                onChange={(e) => setTypeCategory(e.target.value)}
                                            />
                                            <span>Diverting (Straight)</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="typeCategory"
                                                value="3"
                                                onChange={(e) => setTypeCategory(e.target.value)}
                                            />
                                            <span>Adjust (Straight)</span>
                                        </label>
                                    </div>
                                </td>
                                <td>
                                    <div className="input-radio">
                                        <label>
                                            <input
                                                type="radio"
                                                name="materialCategory"
                                                value="0"
                                                onChange={(e) => setMaterialCategory(e.target.value)}
                                            />
                                            <span>Mild Steel</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="materialCategory"
                                                value="1"
                                                onChange={(e) => setMaterialCategory(e.target.value)}
                                            />
                                            <span>Stainless Steel</span>
                                        </label>
                                    </div>
                                </td>
                                <td>{standardWeight}</td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={factor}
                                        onChange={(e) => setFactor(e.target.value)}
                                    />
                                </td>
                                <td>{unitWeight}</td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={qty}
                                        onChange={(e) => setQty(e.target.value)}
                                    />
                                </td>
                                <td className="total-weight">{weight}</td>
                                <td className="btn-add" onClick={onAddChuteDamper}>
                                    <MdAdd />
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={5}>Chute(Damper) Total</td>
                                <td></td>
                                <td>{totalQty}</td>
                                <td>{totalWeight}</td>
                            </tr>
                        </tfoot>
                    </table>
                    {/* <ActionButtons confirmText="Save" cancelText="Cancel Change" onConfirm={onSaveChuteDamper} onCancel={onClickCancel} /> */}
                    {/* <AskCancelModal visible={modal} onConfirm={onCancelChange} onCancel={() => setModal(false)} /> */}
                </>
            )}
        </ChuteDamperFormBlock>
    );
};

/* =================   Styles   ================== */
const Title = styled.div`
    display: flex;
    align-items: flex-end;
    margin-bottom: 1rem;

    color: ${palette.cyan[6]};
`;

const ChuteDamperFormBlock = styled.div`
    // max-width: 1280px;
    // margin: 0 auto;
    // margin: 0 2rem;
    .btn-delete {
        color: ${palette.cyan[6]};
        font-size: 1rem;
        cursor: pointer;
        padding: 0 1rem;
        padding-top: 0.3rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    .btn-add {
        color: ${palette.cyan[6]};
        font-size: 1.5rem;
        cursor: pointer;
        padding: 0;
        padding-top: 0.4rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    table {
        width: 100%;
        font-size: 0.9rem;
        border-collapse: collapse;
    }
    thead {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        color: ${palette.gray[7]};
    }
    tfoot {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        height: 2.5rem;
        font-weight: bold;
        color: ${palette.gray[7]};
    }
    th {
        padding: 0.5rem 0.25rem;
        text-align: center;
    }
    td {
        padding: 0.25rem 0.25rem;
        text-align: center;
    }
    .td-radio {
        display: flex;
        justify-content: center;
        margin: 0 auto;
    }
    .input-radio {
        display: flex;
        flex-direction: column;
        // margin: 0 auto;
        align-items: flex-start;
        span {
            margin-left: 0.5rem;
        }
        // 추가함
        label + label {
            margin-top: 0.5rem;
        }
    }
    h3 {
        color: ${palette.cyan[6]};
    }
    .input-form {
        background-color: ${palette.gray[0]};
    }
`;

const StyledInput = styled.input`
    border: none;
    outline: none;
    padding: 0.25rem 0.5rem;
    width: 50px;
    text-align: center;
    background: transparent;
    &:hover {
        background: ${palette.gray[3]};
    }
`;

export default ChuteDamperForm;
